import type { DiscoveryGetTrends200PageAllOfThreeContentItemContentTweetsItemMediaLinksItemLinkType } from './discoveryGetTrends200PageAllOfThreeContentItemContentTweetsItemMediaLinksItemLinkType';
import type { DiscoveryGetTrends200PageAllOfThreeContentItemContentTweetsItemMediaLinksItemProjectInfo } from './discoveryGetTrends200PageAllOfThreeContentItemContentTweetsItemMediaLinksItemProjectInfo';

/**
 * 링크 프리뷰 정보
 */
export type DiscoveryGetTrends200PageAllOfThreeContentItemContentTweetsItemMediaLinksItem = {
  /** 웹페이지 설명 */
  description?: string;
  /** 사이트 파비콘 URL */
  favicon?: string;
  /** 링크 유형 (외부 링크 또는 프로젝트 링크) */
  linkType?: DiscoveryGetTrends200PageAllOfThreeContentItemContentTweetsItemMediaLinksItemLinkType;
  /** 프로젝트 링크인 경우 추가 정보 (우리 사이트 내부 링크) */
  projectInfo?: DiscoveryGetTrends200PageAllOfThreeContentItemContentTweetsItemMediaLinksItemProjectInfo;
  /** 사이트 이름 */
  siteName?: string;
  /** 프리뷰 썸네일 URL */
  thumbnailUrl?: string;
  /** 웹페이지 제목 */
  title?: string;
  /** 원본 URL */
  url?: string;
};
